import { useEffect } from 'react';

import { fireGtmDataLayerVariable } from 'utils/postEnrollmentHelper';
import { getAnonymousId } from 'utils/segment';

export const OldGtmFireEffect = () => {
  useEffect(() => {
    fireGtmDataLayerVariable({ segmentAnonymousId: getAnonymousId() });
    // eslint-disable-next-line no-console
    console.log('OldGtmFireEffect FIRED');
  }, []);

  return null;
};
